import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { NotificationProvider } from "./contexts/NotificationContext";
import { ModalProvider } from "./contexts/ModalContext";
import { GlobalModals } from "./components/GlobalModals";
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // [NEW] PWA
import { applyFontScale, getSavedFontScale } from "./utils/fontScale";

import "./styles.css";
import App from "./App";

applyFontScale(getSavedFontScale());

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <NotificationProvider>
      <ModalProvider>
        <App />
        <GlobalModals />
      </ModalProvider>
    </NotificationProvider>
  </StrictMode>
);

// [NEW] Service Worker registration
if (process.env.NODE_ENV === "production") {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}
